<template>
  <div class="flex w-full max-w-[497px] flex-col pt-7">
    <!-- <div
      class="mb-5 font-roboto text-[26px] font-semibold leading-8 tracking-wider"
    >
      Новое
    </div> -->
    <div class="mb-4">
      <WikiNewCard
        v-for="article in wikisData"
        :key="article.id"
        :data="article"
        class="shrink-0"
      />
    </div>
    <NuxtLink
      to="/encyclopedia/catalog"
      class="text-[16px] leading-4 2xl:mt-auto"
      >Смотреть все</NuxtLink
    >
  </div>
</template>

<script setup>
const { isMobile } = useBreakpoint();

const perPage = computed(() => (isMobile.value ? 4 : 12));

const { wikis } = useWikis({
  per_page: perPage,
  filters: { sort: 'last', random: true },
});

const wikisData = computed(() => wikis.data.value?.data || []);
</script>
